import AkRelationDataTable from '../../../../spine-appkit-vue/src/components/grid/AkRelationDataTable';


AkRelationDataTable.methods.showMediaInspector = function($event) {
    let params = this.$route.params;

    // If there is no relationString present currently and we have a baseRelationString given
    // We use that one
    if(! params.relationString && this.baseRelationString) {
        params.relationString = this.baseRelationString;
    }

    // add the formDefinition & object Id to the relation ID
    params.relationString = params.relationString + ':media-inspector:' + $event.objectId;

    //redirect to the new relation state
    this.$router.push({ name: this.$route.name , params: params});
};

Vue.asyncComponent('cms-media-relation-data-table', AkRelationDataTable, 'cms/media/cms-media-relation-data-table.html');